import {createContext} from 'react';

export type UploadContactListContextType = {
	activeStep: number;
	handleNextStep: () => void;

	selectedFile: File | null;
	setSelectedFile: (file: File | null) => void;

	sheetName: string;
	setSheetName: (sheetName: string) => void;

	onCloseModal: () => void;

	headerIndex: number | null;
	setHeaderIndex: (index: number | null) => void;

	existingContactList: Record<string, any>;
	setExistingContactList: (contactList: Record<string, any>) => void;

	manageDuplicate: string;
	setManageDuplicate: (manageDuplicate: string) => void;

	columnForDuplicate: string;
	setColumnForDuplicate: (columnForDuplicate: string) => void;
};

export const UploadContactListContext = createContext({} as UploadContactListContextType);
